/**
 * 解析URL的查询参数
 * @param  {string} url 传入的urlstring，为空则解析当前页的url查询部分
 * @return {object}     查询url解析出的键值对没有则为undefined或空对象
 */
function parseUrl(url) {
    var search = url || window.location.search;
    var reg = new RegExp( "([^?=&]+)(=([^&]*))?", "g" );
    var data = {};
    if(search){
        search.replace(reg,function( $0, $1, $2, $3 ){
            data[ $1 ] = decodeURIComponent($3);
        });
    }
    return data;
}
export default parseUrl;